import { render, staticRenderFns } from "./AddItemCard.vue?vue&type=template&id=461e88c7&scoped=true&"
import script from "./AddItemCard.vue?vue&type=script&lang=js&"
export * from "./AddItemCard.vue?vue&type=script&lang=js&"
import style0 from "./AddItemCard.vue?vue&type=style&index=0&id=461e88c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e88c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
